export default __webpack_public_path__ + "static/media/eloho.12d732f4.png";